import $api from "../http";
import { IReview } from "../models/Review";

class ReviewServiceClass {
  getReviews(
    currentPage: number | undefined,
    pageSize: number | undefined,
    queryOptions?: { from: string | null; to: string | null }
  ) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    if (queryOptions) {
      if (queryOptions.from) {
        queryString += `&fromDate=${queryOptions.from}`;
      }
      if (queryOptions.to) {
        queryString += `&toDate=${queryOptions.to}`;
      }
    }
    return $api.get<{ data: IReview[]; totalCount: number }>(`api/review?${queryString}`);
  }

  deleteReview(id: string) {
    return $api.delete<{}>(`api/review/${id}`);
  }

  reportReview(id: string) {
    return $api.put<{}>(`api/review/report/${id}`);
  }
}

export const ReviewService = new ReviewServiceClass();
